import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { renderErrors, renderMessages } from '../../render';
import validateField from '../../validation';
import LanguageToggle from './../../core/language-toggle/LanguageToggle';
import { requestResetPassword } from '../../../actions/request-reset-password-actions';
import { withTranslation } from 'react-i18next';
import './RequestResetPassword.scss';

class RequestResetPassword extends React.Component {
	/**
     * 
     * @param {*} props 
     */
	constructor(props) {
		super(props);
		this.state = {
			username: '',
			formValid: false
		};
	}
	/**
     * 
     */
	handleSubmitClick = () => {
		//
		this.props.requestResetPassword(this.state.username);
	};

	/**
     * 
     * @param {*} e 
     */
	handleChange(e) {
		this.setState({ [e.target.id]: e.target.value });
		//
		setTimeout(this.validateForm.bind(this, 200));
	}

	/**
     * 
     */
	validateForm() {
		if (validateField('username', this.state.username) === true) {
			this.setState({ formValid: true });
		} else {
			this.setState({ formValid: false });
		}
	}

	/**
     * 
     */
	render() {
		return (
			<div className="RequestResetPassword">
				<div className="container">
					<div className="simpleMenu">
						<LanguageToggle />
					</div>

					<h1>
						{this.props.t('translation:requestResetPassword:headerLbl')}
					</h1>
					<form noValidate autoComplete="off">
						<div className="formBox">
							<div>
								<TextField
									id="username"
									label={this.props.t('translation:resetPassword:usernameInputLabel')}
									margin="normal"
									variant="outlined"
									value={this.state.username}
									disabled={this.state.isLoading}
									onChange={e => this.handleChange(e)}
								/>
							</div>
						</div>
						<div className="feedbackBox">
							<div>
								{renderMessages.bind(this)(this.props.messages)}
							</div>
							<div>
								{renderErrors.bind(this)(this.props.errors)}
							</div>
						</div>
						<div>
							<div>
								<Button className="btnAction" variant="contained" color="primary" onClick={this.handleSubmitClick} disabled={this.props.isLoading || !this.state.formValid}>
									{this.props.t('translation:requestResetPassword:submitButtonLabel')}
								</Button>
								<div className="links">
									<Link to={'/signin'}>{this.props.t('translation:requestResetPassword:gotoSignInButtonLabel')}</Link> |{' '}
									<Link to={'/reset-password'}>{this.props.t('translation:requestResetPassword:gotoResetPasswordButtonLabel')}</Link>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		);
	}
}

/**
 * 
 * @param {*} state 
 */
const mapStateToProps = state => {
	return {
		isLoading: state.requestResetPassword.isLoading,
		errors: state.requestResetPassword.errors,
		messages: state.requestResetPassword.messages
	};
};

/**
 * 
 * @param {*} dispatch 
 */
const mapDispatchToProps = dispatch => {
	return {
		requestResetPassword: (username, code, newPassword) => dispatch(requestResetPassword(username, code, newPassword))
	};
};
/**
 * 
 */
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RequestResetPassword));
